/**
 * Message de toast unifié pour l'(dés)assignation d'un commercial sur une demande.
 * Partagé entre le détail d'une demande (useQuoteDetailAssign) et la liste
 * (useQuotesListCommercials) pour éviter la divergence des libellés.
 *
 * « Vous » n'apparaît que si l'action porte sur l'utilisateur courant lui-même
 * (basé sur l'identité réelle avant/après, pas sur le rôle).
 */
export function buildAssignmentToastMessage({
  isUnassigning,
  previousAssignedId,
  assignedId,
  currentUserId,
  availableCommercials
}) {
  if (isUnassigning) {
    return previousAssignedId === currentUserId
      ? 'Vous avez été désassigné de cette demande'
      : 'Commercial désassigné avec succès'
  }

  if (assignedId === currentUserId) {
    return 'Vous avez été assigné à cette demande'
  }

  const selected = availableCommercials.find(c => c.id === assignedId)
  return selected?.email
    ? `Commercial ${selected.email} assigné avec succès`
    : 'Commercial assigné avec succès'
}
